import { observable } from 'mobx'
import { Model } from 'libx'

export default class Conversation extends Model {
  @observable hasMoreMessages = false
  @observable loadingMore = false
  @observable paginationWindow = 30 // First time around we load 30 messages
}



// WEBPACK FOOTER //
// ./src/client/domain/Conversation.js